import {
  List,
  ListItem,
  ListSubheader,
  TextField,
  makeStyles,
} from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslate, useUpdate } from "react-admin";

import AddDocButton from "../buttons/AddDocButton";
import Docs from "./Docs";
import { get } from "lodash";
import { useDebounce } from "ra-friendsofbabba";

const useStyles = makeStyles((theme) => ({
  textarea: {
    width: 300,
  },
}));

const AdmissibilityNotes = ({ record, maxWidth = 250 }) => {
  const translate = useTranslate();
  const classes = useStyles();
  const [value, setValue] = useState(
    get(record, "admissibility_notes", "") || ""
  );
  const debouncedValue = useDebounce(value, 3000);
  const didMount = useRef(false);
  const didUpdate = useRef(false);
  const [update] = useUpdate();
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    if (didUpdate.current) {
      didUpdate.current = false;
      return;
    }
    didUpdate.current = true;

    update(
      "research-projects",
      record.id,
      {
        ...record,
        admissibility_notes: debouncedValue,
        state: "admissibility_notes",
      },
      record
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue, update]);
  const handleChange = useCallback((e) => {
    if (didUpdate.current) {
      didUpdate.current = false;
      return;
    }
    setValue(e.target.value);
  }, []);
  return (
    <List>
      <ListSubheader>
        {translate("resources.research-projects.fields.notes")}
      </ListSubheader>
      <ListItem dense>
        <TextField
          multiline
          style={{ maxWidth }}
          className={classes.textarea}
          value={value}
          onChange={handleChange}
          variant="standard"
        />
      </ListItem>
      <Docs
        sub
        record={record}
        maxWidth={maxWidth}
        title="resources.research-projects.fields.email_docs"
        filter={(doc) => doc.type === 2}
      />
      <ListItem>
        <AddDocButton
          record={record}
          resource="research-projects"
          source="docs"
        />
      </ListItem>
    </List>
  );
};

export default AdmissibilityNotes;
